"use client";

import React from "react";
import { withRef } from "@udecode/cn";
import {
	PlateElement,
	useElement,
	useEditorReadOnly,
} from "@udecode/plate-common";
import { TLinkElement, useLink } from "@udecode/plate-link";

export const LinkElement = withRef<typeof PlateElement>(
	({ className, children, ...props }, ref) => {
		const element = useElement<TLinkElement>();
		const { props: linkProps } = useLink({ element });
		const isEditorReadonly = useEditorReadOnly();
		const isEditMode = !isEditorReadonly;

		return (
			<PlateElement
				ref={ref}
				asChild
				className={className}
				{...(linkProps as any)}
				data-prevent-nprogress={
					linkProps.target === "_blank" ||
					isEditMode /* internal links when in readonly mode should trigger the NProgress bar */
				}
				{...props}
			>
				<a>{children}</a>
			</PlateElement>
		);
	}
);
